module.exports = __webpack_public_path__ + "img/fingers.c7ba1944.png";